import {
    apiRequest,
    configTunjanganDetail
} from "../../../../../services/adapters/kepegawaian/configTunjanganService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", configTunjanganDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository